import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { renderSnackbarNotificationHiddenItems } from "@src/components/organisms/tree-structure/use-cases/render-snackbar-reminder-hidden-items";
import { useEffect, useState } from "react";

type StructureType = "machine" | "initial";

export const useNodesCounterSelectorHook = (structure: StructureType) => {
  const structureNodesetInstance =
    structure === "machine"
      ? getMachineStructureNodeset()
      : getInitialStructureNodeset();

  const flatMap = structureNodesetInstance.getFlatMap();
  const filteredFlatMap = structureNodesetInstance.getFilteredFlatMap();

  const [filteredFlatMapSize, setFilteredFlatMapSize] = useState(
    filteredFlatMap.size,
  );

  const [selectedNodesCount, setSelectedNodesCount] = useState(0);
  const [hiddenCount, setHiddenCount] = useState(0);
  const [selectedFilteredNodesCount, setSelectedFilteredNodesCount] =
    useState(0);

  const handleClickSelectAllFiltered = () => {
    structureNodesetInstance.selectFilteredNodes();
  };

  const handleClickSelectAll = () => {
    structureNodesetInstance.selectAllNodes();
  };

  const handleClickDeselectAll = () => {
    structureNodesetInstance.deselectAllNodes();
  };

  const handleClickDeselectAllFiltered = () => {
    structureNodesetInstance.deselectFilteredNodes();
  };

  useEffect(() => {
    const calculateHiddenSelectedCount = () => {
      structureNodesetInstance.calculateSelectedHiddenNodesSet();

      setHiddenCount(structureNodesetInstance.getSelectedHiddenNodesSet().size);

      if (
        structureNodesetInstance.getSelectedHiddenNodesSet().size > 0 &&
        structureNodesetInstance.filteredFlatMap.size > 0
      ) {
        renderSnackbarNotificationHiddenItems();
      }
    };

    calculateHiddenSelectedCount();
  }, [structureNodesetInstance, flatMap, filteredFlatMap.size]);

  useEffect(() => {
    const updateSize = () => {
      setFilteredFlatMapSize(
        structureNodesetInstance.getFilteredFlatMap().size,
      );
    };

    structureNodesetInstance.addObserver(updateSize);

    updateSize();

    return () => {
      structureNodesetInstance.removeObserver(updateSize);
    };
  }, [structureNodesetInstance]);

  useEffect(() => {
    const updateCount = () => {
      const selectedCount = structureNodesetInstance.selectedNodeIds.size;
      setSelectedNodesCount(selectedCount);
    };

    updateCount();

    structureNodesetInstance.addObserver(updateCount);

    return () => {
      structureNodesetInstance.removeObserver(updateCount);
    };
  }, [structureNodesetInstance, filteredFlatMap.size]);

  useEffect(() => {
    setSelectedFilteredNodesCount(selectedNodesCount - hiddenCount);
  }, [selectedNodesCount, hiddenCount]);

  return {
    selectedNodesCount,
    hiddenCount,
    filteredFlatMapSize,
    selectedFilteredNodesCount,
    handleClickDeselectAll,
    handleClickDeselectAllFiltered,
    handleClickSelectAll,
    handleClickSelectAllFiltered,
  };
};
